import {
  profilePage,
  analyticsPage,
  employeesPage,
  cashboxPage,
  inventoriesPage,
  purchasesPage,
  salesPage,
  salesReportPage,
  selectStorePage,
  supplyPage,
  discountPage,
  storagePage,
  ukmPage,
  paymentPage,
  reportsPage,
  addProductPage,
} from "./routesInfo"

export class SidebarMenuItem {
  constructor(route, title, icon, onSelect) {
    this.route = route
    this.title = title
    this.icon = icon
    this.onSelect = onSelect
  }
}

export const sidebarMenuItems = [
  new SidebarMenuItem(profilePage, "profilePage"),
  new SidebarMenuItem(analyticsPage, "analyticsPage"),
  new SidebarMenuItem(supplyPage, "supplyPage"),
  new SidebarMenuItem(discountPage, "discountPage"),
  new SidebarMenuItem(purchasesPage, "purchasesPage"),
  new SidebarMenuItem(salesPage, "salesPage"),
  new SidebarMenuItem(salesReportPage, "salesReportPage"),
  new SidebarMenuItem(selectStorePage, "selectStorePage"),
  new SidebarMenuItem(cashboxPage, "cashboxPage"),
  new SidebarMenuItem(employeesPage, "employeesPage"),
  // new SidebarMenuItem(storagePage, "storagePage"),
  new SidebarMenuItem(inventoriesPage, "inventoriesPage"),
  // new SidebarMenuItem(paymentPage, "paymentPage"),
  // new SidebarMenuItem(ukmPage, "УКМ"),
  // new SidebarMenuItem(reportsPage, "Reports"),
  // new SidebarMenuItem(addProductPage, "addProduct"),
]
